// src/services/WebSocketService.js

import SockJS from "sockjs-client";
import Stomp from "stompjs";
import WebsocketHelper from "./WebsocketHelper"; // Adjust the path as needed
import { timeInterval, webSocket } from "./config"; // Adjust the path as needed
import axiosIns from "@/libs/axios"; // Adjust the path as needed

export default class WebSocketService {
  static stompClient = null;
  static socket = null;
  static isConnection = false;
  static dynamicPart = ""; // Store the dynamic part here

  static async getStompClient() {
    if (WebSocketService.stompClient && WebSocketService.isConnection) {
      return WebSocketService.stompClient;
    } else {
      console.warn("Waiting for WebSocket connection...");
      await WebsocketHelper.promiseTimeout(
        timeInterval.WS_CONNECTION_WAIT_TIME
      );
      return await this.getStompClient();
    }
  }

  static connect(callback) {
    WebSocketService.isConnection = false;

    const url =
      "https://www.shipper-store.com/messages/spring-boot-progressbar-websocket";

    try {
      // Create a new SockJS instance
      WebSocketService.socket = new SockJS(url);

      WebSocketService.stompClient = Stomp.over(WebSocketService.socket);
      // WebSocketService.stompClient.debug = (str) => {
      //   console.log(str);
      // };

      WebSocketService.stompClient.connect(
        {},
        (frame) => {
          // console.log("WebSocket connection frame:", frame);
          WebSocketService.isConnection = true;

          const transportUrl = WebSocketService.getTransportUrl();
          if (transportUrl) {
            WebSocketService.dynamicPart = transportUrl.split("/").slice(-2)[0]; // Extract the last part
            sessionStorage.setItem(
              "transportURL",
              transportUrl.split("/").slice(-2)[0]
            );
          } else {
            console.warn("Failed to retrieve transport URL.");
            // Handle the case where transportUrl is null
          }
        },
        (error) => {
          console.error("WebSocket connection error:", error);
          WebSocketService.isConnection = false;
          if (callback) {
            callback({
              sessionId: null,
              status: "CONNECTION_ERROR",
              message: "WebSocket connection error!!",
            });
          }
        }
      );
    } catch (error) {
      console.error("Error initializing WebSocket connection:", error);
      if (callback) {
        callback({
          sessionId: null,
          status: "INITIALIZATION_ERROR",
          message: "Error initializing WebSocket connection",
        });
      }
    }
  }

  static disconnect() {
    if (WebSocketService.stompClient) {
      WebSocketService.stompClient.disconnect(() => {
        console.log("WebSocket connection is closed successfully.");
        WebSocketService.isConnection = false;
      });
    }
  }

  static async subscribe(callback, url) {
    try {
      // Attempt to get the Stomp client
      const stompClient = await this.getStompClient();

      // Check if the stomp client and dynamicPart are available
      if (stompClient && WebSocketService.dynamicPart) {
        // Construct the subscription endpoint
        const subscriptionEndpoint = `${webSocket.SUBSCRIBE}_${WebSocketService.dynamicPart}`;
        // Attempt to subscribe to the endpoint
        stompClient.subscribe(url, (tick) => {
          if (!tick || !tick.body) {
            // Log the received tick if invalid

            this.disconnect();
          } else {
            // Parse and log the received tick body
            const tickBody = JSON.parse(tick.body);

            // Check status and disconnect if necessary
            if (
              tickBody.status === webSocket.SUCCESS ||
              tickBody.status === webSocket.ERROR
            ) {
              this.disconnect();
            }

            // Execute the callback with the tick body
            if (callback) callback(tickBody);
          }
        });
      } else {
        // Log if the subscription cannot proceed due to missing requirements
        console.warn("Stomp client or dynamicPart not available.");
      }
    } catch (error) {
      // Log any errors encountered during the subscription process
      console.error("Subscription error:", error);
    }
  }

  static async sendMessage(destination, msg) {
    try {
      const stompClient = await this.getStompClient();

      if (stompClient && WebSocketService.isConnection) {
        stompClient.send(destination, {}, JSON.stringify(msg));
      } else {
        console.error("Cannot send message: WebSocket is not connected.");
      }
    } catch (error) {
      console.error("Error sending message:", error);
    }
  }

  // New method to get the transport URL
  static getTransportUrl() {
    if (WebSocketService.stompClient && WebSocketService.stompClient.ws) {
      const transport = WebSocketService.stompClient.ws._transport;
      if (transport && transport.url) {
        return transport.url;
      }
    }
    return null;
  }
}
